/**
 * 弹窗组件
 */
import { i18n } from '../core/I18n.js';

export class Modal {
  constructor(options = {}) {
    this.title = options.title || '';
    this.content = options.content || '';
    this.icon = options.icon || '🎉';
    this.buttons = options.buttons || [];
    this.onClose = options.onClose || (() => {});
    this.element = this.render();
  }
  
  render() {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    
    const content = document.createElement('div');
    content.className = 'modal-content';
    
    content.innerHTML = `
      <div class="modal-icon">${this.icon}</div>
      <h2 class="modal-title">${this.title}</h2>
      <div class="modal-text">${this.content}</div>
    `;
    
    // 按钮
    if (this.buttons.length > 0) {
      const actions = document.createElement('div');
      actions.className = 'modal-actions';
      
      this.buttons.forEach(btn => {
        const button = document.createElement('button');
        button.className = `btn ${btn.primary ? 'btn-primary' : 'btn-secondary'}`;
        button.textContent = btn.text;
        button.addEventListener('click', () => {
          if (btn.onClick) btn.onClick();
          if (btn.close !== false) this.hide();
        });
        actions.appendChild(button);
      });
      
      content.appendChild(actions);
    }
    
    overlay.appendChild(content);
    
    // 点击遮罩关闭
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        this.hide();
      }
    });
    
    return overlay;
  }
  
  show() {
    document.body.appendChild(this.element);
    // 强制重绘以触发过渡动画
    this.element.offsetHeight;
    this.element.classList.add('active');
  }
  
  hide() {
    this.element.classList.remove('active');
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.parentNode.removeChild(this.element);
      }
      this.onClose();
    }, 300);
  }
  
  /**
   * 快速创建完成弹窗
   */
  static createCompleteModal(stats = {}, onRestart, onBack) {
    const lang = i18n.getLanguage();
    
    let content = `<p>${i18n.t('completed')}</p>`;
    
    if (stats.score !== undefined || stats.time !== undefined) {
      content += '<div style="margin: 1rem 0; padding: 1rem; background: #F3F4F6; border-radius: 1rem;">';
      if (stats.score !== undefined) {
        content += `<div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
          <span>${i18n.t('score')}</span>
          <strong>${stats.score}</strong>
        </div>`;
      }
      if (stats.time !== undefined) {
        const mins = Math.floor(stats.time / 60).toString().padStart(2, '0');
        const secs = (stats.time % 60).toString().padStart(2, '0');
        content += `<div style="display: flex; justify-content: space-between;">
          <span>${i18n.t('time')}</span>
          <strong>${mins}:${secs}</strong>
        </div>`;
      }
      content += '</div>';
    }
    
    // 星星评分
    if (stats.stars) {
      content += '<div class="star-rating">';
      for (let i = 0; i < 3; i++) {
        content += `<span class="star" style="animation-delay: ${i * 0.2}s">${i < stats.stars ? '⭐' : '⚫'}</span>`;
      }
      content += '</div>';
    }
    
    return new Modal({
      title: i18n.t('congrats'),
      content,
      icon: '🎉',
      buttons: [
        {
          text: i18n.t('btn.playAgain'),
          primary: true,
          onClick: onRestart
        },
        {
          text: i18n.t('btn.back'),
          onClick: onBack
        }
      ]
    });
  }
}
